import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import ALNJobInformation from '../images/aln-job-information.png';
import {
  GelContentContainer,
  GelContentColumn,
  GelContentRow,
  List,
  RegularCard, ButtonCta, SideNavigation
} from "cw-styleguide-react";
import {route} from "../routes";
import Helmet from 'react-helmet';

class ResultView extends Component {
  render() {

    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('misc.results')} | {this.props.t('app.name')}</title>
        </Helmet>
        <GelContentContainer>
          <h1>{this.props.title}</h1>
          <GelContentRow>
            <GelContentColumn md={3}>
              <SideNavigation
                title={this.props.t('misc.contents')}
                items={[
                  {
                    text: this.props.t('misc.strengthsTitle'),
                    url: '#strengths'
                  },
                  {
                    text: this.props.t('misc.jobLikesTitle'),
                    url: '#likes'
                  },
                  {
                    text: this.props.t('misc.jobTypesTitleShort'),
                    url: '#types'
                  },
                  {
                    text: this.props.t('misc.friendTitle'),
                    url: '#friend'
                  },
                  {
                    text: this.props.t('misc.tipsTitle'),
                    url: '#tips'
                  },
                  {
                    text: this.props.t('misc.funTitle'),
                    url: '#fun'
                  }
                ]}
              />
            </GelContentColumn>
            <GelContentColumn md={9}>
              <h2 id={'strengths'} className={'h3'}>{this.props.t('misc.strengthsTitle')}</h2>
              <List styles={['list-square', 'columns-2']} items={this.props.strengths}/>

              <h2 id={'likes'} className={'h3'}>{this.props.t('misc.jobLikesTitle')}</h2>
              <List styles={['list-square', 'columns-2']} items={this.props.jobLikes}/>

              <h2 id={'types'} className={'h3'}>{this.props.t('misc.jobTypesTitle')}</h2>
              <GelContentRow>
                {this.props.jobTypes.map((job, index) => {
                  return (
                    <RegularCard key={index} width={33} link={false} alt={job.altText}
                                 source={job.imageUrl} title={job.name}/>
                  );
                })}
              </GelContentRow>

              {/*<GelContentRow>*/}
              {/*  <IconCard*/}
              {/*    link={{to: this.props.t('misc.jobInformationUrl')}}*/}
              {/*    alt={this.props.t('misc.jobInformationTitle')}*/}
              {/*    source={ALNJobInformation}*/}
              {/*    title={this.props.t('misc.jobInformationTitle')}*/}
              {/*    colour={'gel-white'}*/}
              {/*  >*/}
              {/*    {this.props.t('misc.jobInformationBody')}*/}
              {/*  </IconCard>*/}
              {/*</GelContentRow>*/}
              <hr/>

              <h2 id={'friend'} className={'h3'}>{this.props.t('misc.friendTitle')}</h2>
              <p>{this.props.friend}</p>

              <h2 id={'tips'} className={'h3'}>{this.props.t('misc.tipsTitle')}</h2>
              {this.props.tips.map((tip, index) => {
                return (
                  <p key={index}>{tip}</p>
                );
              })}

              <h2 id={'fun'} className={'h3'}>{this.props.funTitle}</h2>
              <GelContentRow>
                <GelContentColumn xs={4}>
                  <img src={this.props.funImage} alt={this.props.funAlt}/>
                </GelContentColumn>
                <GelContentColumn xs={8}>
                  {this.props.funText.map((item, index) => {
                    return (
                      <p key={index}>{item}</p>
                    );
                  })}
                </GelContentColumn>
              </GelContentRow>



              <h2 className={'h3'}>{this.props.fictionalTitle}</h2>
              <GelContentRow>
                {this.props.fictionalPeople.map((person, index) => {
                  return (
                    <RegularCard key={index} width={33} link={false} alt={person.altText}
                                 source={person.imageUrl} title={person.name}/>
                  );
                })}
              </GelContentRow>

              <ButtonCta url={route('whoAmI')} onClick={this.props.handleReset}>
                {this.props.t('misc.retake')}
              </ButtonCta>
            </GelContentColumn>
          </GelContentRow>
        </GelContentContainer>
      </Fragment>
    );
  }
}


export default withTranslation('local')(ResultView);
